'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:QuotationShowCtrl
 * @description
 * # QuotationShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('QuotationShowCtrl', [
    '$scope', '$rootScope', '$mdDialog', '$state', '$stateParams', 'Quotation', 'GoogleApi', 'Client', 'Project', 'toaster', 'cfpLoadingBar',
    function ($scope, $rootScope, $mdDialog, $state, $stateParams, Quotation, GoogleApi, Client, Project, toaster, cfpLoadingBar) {
      const clientBaseFolderId = GoogleApi.getClientBaseFolderId();
      $scope.quotation = {};
      $scope.hasAction = true;
      Quotation.find($stateParams.quotationId).then(function(response) {
        $scope.quotation = response.data.quotation;
        $scope.hasAction = $scope.quotation.permitted_events.length != 0;
      }, function(error) {
        Quotation.error(error);
      });
      $scope.clientHash = {
        'client': {
          'name': '',
          'client_code': '0',
          'drive_root_id': 'Placeholder',
          'drive_root_url': 'Placeholder'
        }
      };
      $scope.projectHash = {
        'project': {
          'name': '',
          'project_date': new Date(),
          'eta': new Date(),
          'audit_comment': '',
          'drive_root_id': 'Placeholder',
          'drive_root_url': 'Placeholder',
          'client_id': 'Placeholder',
          'project_type_catalog_id': '',
          'product_catalog_id': '',
        }
      }
      $rootScope.rootPath = {
        url: `https://drive.google.com/drive/folders/${clientBaseFolderId}`,
        id: clientBaseFolderId,
        name: 'Clientes'
      };

      $scope.selectFolder = function(event) {
        GoogleApi.pickerApiLoad(clientBaseFolderId, 'folder');
        $rootScope.event = event;
        $rootScope.isQuotation = true;
      }

      $rootScope.changeState = function(state) {
        if(state.name === 'Finalizada') {
          $scope.title = state.name + '/Alta Cliente'
        } else {
          $scope.title = state.name;
        }
        Client.next_client_code().then((response) => {
          $scope.clientHash.client.client_code = response.data.client_code
        })
        var currentScrollPosition = window.scrollY;
        $mdDialog.show({
          controller: $rootScope.QuoteCommentCtrl,
          templateUrl: 'views/quote_comment_dialogue.html',
          scope: $scope,
          preserveScope: true,
          onRemoving: function() {
            window.scrollTo(0, currentScrollPosition);
          }
        }).then((result) => {

          $scope.quotationHash = {
            'quotation':  $scope.quotation
          };

          $scope.quotationHash.state = state.event;
          $scope.quotationHash.quotation.audit_comment = result.comment;

          $scope.clientHash.client.name = $scope.quotation.prospect.name;

          $scope.projectHash.project.name = result.project_name;
          $scope.projectHash.project.project_date = result.project_date;
          $scope.projectHash.project.eta = result.eta;
          $scope.projectHash.project.audit_comment = "Creacion automatica de proyecto a partir de cotización";
          $scope.projectHash.project.project_type_catalog_id = 6;
          $scope.projectHash.project.product_catalog_id = $scope.quotation.product_catalog.id;

          $scope.quotationHash.quotation.client_hash = $scope.clientHash.client;
          $scope.quotationHash.quotation.project_hash = $scope.projectHash.project;

          Quotation.aasm_transition($scope.quotationHash).then((response) => {
            if(state.event === "approve_demo") {
              GoogleApi.createQuotationsFolder(
                $scope.quotationHash.quotation.prospect.name,
                $scope.quotationHash.quotation.prospect.drive_root_id
              );
            } else if(state.event === "request_contract") {
              GoogleApi.createQuotationProspectFolder(
                $scope.quotationHash.quotation.prospect.drive_root_id
              );
            }
            else if(state.event === "approve_quote") {
              cfpLoadingBar.start();
              const rootGoogleFolderId = $rootScope.rootPath.id;
              $scope.clientHash.client = response.data.client;
              $scope.projectHash.project = response.data.project;
              //Change from Quotation/Prospect to Project/client
              //First step: Create Client Drive Strucuture
              Project.getNextProjectCode().then((response) => {
                const projectCode = response.data.next_project_code;
                const projectFolderName = `${projectCode}_${$scope.projectHash.project.name}`;
                GoogleApi.createClientFolderStructure(
                  $scope.quotationHash.quotation.prospect.name,
                  $scope.quotationHash.quotation.prospect.drive_root_id,
                  projectFolderName,
                  projectCode,
                  rootGoogleFolderId
                ).then((response) => {
                  //Response will have .client_root_id, .project_root_id
                  //Second step: Create Client
                  $scope.clientHash.client.drive_root_id = response.client_root_id;
                  $scope.clientHash.client.drive_root_url = response.client_root_url;

                  Client.save($scope.clientHash).then((response) => {
                    toaster.pop('success', 'Creación de Cliente', 'Se creo el cliente ' + response.data.client.name + ' exitosamente.' );
                    $scope.projectHash.project.client_id = response.data.client.id;

                    // Give it some time while the folders are created
                    setTimeout(() => {
                      cfpLoadingBar.start();
                      console.log("Creating the project folders")
                      GoogleApi.findChildFolder(
                        $scope.clientHash.client.drive_root_id,
                        $scope.projectHash.project.name
                        ).then((response) => {
                        console.log("SUCCESS CREATING THE PROJECT FOLDERS")
                        $scope.projectHash.project.drive_root_id = response.id;
                        $scope.projectHash.project.drive_root_url = response.url;

                        Project.save($scope.projectHash).then(() => {
                          toaster.pop('success', 'Creación de Proyecto', `Se ha guardado exitosamente el proyecto #${projectCode}`);
                        }).catch((err) => {
                          console.log("ERROR CREATING THE PROJECT");
                          console.log(err);
                        }).finally(() => {
                          cfpLoadingBar.complete();
                        });
                      }).catch((error) => {
                        console.log("ERROR CREATINT EH PROJECT FOLDERS");
                        console.log(error);
                      }).finally(() => {
                        cfpLoadingBar.complete();
                      });
                      cfpLoadingBar.complete();
                    }, 10000);
                  }).catch((error) => {
                    console.log("NONOOONONO");
                    //Error while creating Client
                    Client.error(error);
                  });
                }).catch((error) => {
                  //Error while creating Client Drive Structure
                });
              });
            }
            $state.reload();
          }).catch((error) => {
            Quotation.error(error);
          });
        }).catch(() => {});
      };
  }]);
